import React from 'react'
import { Card, Typography, Space } from 'antd'

const { Title, Paragraph } = Typography

export default function SectionCard({ id, title, subtitle, icon, children, extra }) {
  return (
    <div id={id} style={{ scrollMarginTop: 80 }}>
      <Card size="small" style={{ marginBottom: 16 }} extra={extra} bodyStyle={{ paddingTop: 16 }}>
        <Space direction="vertical" size={4} style={{ width: '100%' }}>
          {(title || subtitle) && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {icon && <span style={{ fontSize: 18, color: '#1677ff' }}>{icon}</span>}
              {title && <Title level={4} style={{ margin: 0 }}>{title}</Title>}
            </div>
          )}
          {subtitle && <Paragraph type="secondary" style={{ marginTop: 0 }}>{subtitle}</Paragraph>}
        </Space>
        <div style={{ marginTop: 8 }}>
          {children}
        </div>
      </Card>
    </div>
  )
}
